import { useSelector } from 'react-redux'
import { Cell } from 'recharts'
import { ChartContainer } from '../../../../common/chart/chartContainer'
import Bar from '../../../../common/chart/chartContainer/Bar'
import { Element } from '../../../../common/html/element'
import { Notification } from '../../../../common/notification'
import { formatVal } from '../../../../helpers/value'
import { selectActiveVSIC, selectDataRiskDistribution } from '../store/slice'

export const ChartContent = () => {
  const locale = useSelector((state) => state.i18n.locale)
  const data = useSelector(selectDataRiskDistribution)
  const activeIndustry = useSelector(selectActiveVSIC)

  const renderCustomContent = ({ data }) => {
    return (
      <Element style={{ lineHeight: '24px' }}>
        <Element>{`${activeIndustry?.code} - ${activeIndustry?.name}`}</Element>
        <Element>{`${data?.name}:  ${formatVal(
          data?.percent,
          locale,
          false,
          2,
        )}%`}</Element>
      </Element>
    )
  }
  if (!data.length) {
    return (
      <div className="wh100">
        <Notification value="common.NO_DATA" />
      </div>
    )
  }

  return (
    <>
      <ChartContainer
        data={data}
        width="100%"
        height="100%"
        xAxis={[
          {
            dataKey: 'name',
            height: 16,
            tickStyle: { color: '#3A414B' },
            tickMargin: 4,
          },
        ]}
        yAxis={[
          {
            yAxisId: 'left',
            dataKeys: ['percent'],
            isStackedBar: true,
            tickFormatter: (val) => formatVal(val, locale, false, 0),
            unit: '%',
          },
        ]}
        tooltip={{
          schema: {
            renderCustomContent: renderCustomContent,
          },
        }}
      >
        <Bar yAxisId="left" dataKey="percent" barSize={36} fill="#fff">
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Bar>
      </ChartContainer>
    </>
  )
}
